/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Data UI Hooks
 *
 * Barrel export for all data-related UI hooks
 */

// PERFORMANCE: Explicit exports instead of export * for better tree-shaking

// CSV export
export type { UseCSVExportOptions, CSVExportHook } from "./use-csv-export";
export { useCSVExport } from "./use-csv-export";

// Domain search
export type {
  UseDomainSearchConfig,
  UseDomainSearchReturn,
} from "./use-domain-search";
export { useDomainSearch } from "./use-domain-search";

// File download
export type { DownloadOptions } from "./use-file-download";
export { useFileDownload } from "./use-file-download";

// File input
export type { FileInputOptions } from "./use-file-input";
export { useFileInput } from "./use-file-input";
